import router from './../router/index.js'
var saveQuery = (params) => {
    let query = Object.assign({}, params)
    delete(query.employee_id)
    delete(query.token)
    let route = {
        name: router.currentRoute.name,
        params: router.currentRoute.params,
        query: router.currentRoute.query,
    }
    route.query = Object.assign({}, route.query, {
        searchQuery: JSON.stringify(query),
        p: query.pagination ? query.pagination.current_page : 1
    })
    router.replace(route)
}
var parseQuery = () => {
    let params = router.currentRoute.query
    if (!params.searchQuery) {
        return {
            query: {},
            pagination: {
                current_page: 1,
                total: 1,
                per_page: 10
            }
        }
    }
    return {
        query: JSON.parse(params.searchQuery),
        pagination: {
            current_page: params.p,
            total: 1,
            per_page: 10
        }
    }
}
export { saveQuery, parseQuery }